import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

// Horse head in profile (facing right, three-lock mane) in front of a full moon.
// Drawn on a 64 grid: the moon is the r=31 circle at the centre and the neck ends
// exactly on its lower arc, so the silhouette needs no clip path and the mark can
// render any number of times on one page. public/favicon.svg reuses this path.
export const HORSE_PATH = 'M8.25 51.9Q7.59 46.61 8.29 40.8L5.3 42.26C5 38.8 9.475 34.09 10.22 31.7L6.32 32.79C6.62 29.39 12.58 25.47 13.82 23.3L9.78 23.52C10.3 20.3 17.225 18.22 19.04 16.5Q21.3 14.37 24 13L25.5 12Q26 6 28.5 3.6Q31.6 6.5 31.5 11.5C37 14.2 45 22.5 50 29C54 32 54 39 48.5 41.5C46.8 42.3 44.8 42.6 43 42C41 41.4 38.8 39.2 36.6 38.9C34.2 38.6 29.6 43.6 28.6 39.3C27.6 46.5 33 55 41.58 61.48A31 31 0 0 1 8.25 51.9Z'

interface HorseMarkProps {
    className?: string
}

export const HorseMark: FC<HorseMarkProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 64 64' className={cn('size-7 shrink-0', className)} aria-hidden='true' focusable='false'>
            <circle cx='32' cy='32' r='31' className='fill-lime' />
            <path d={HORSE_PATH} className='fill-ink' />
            <circle cx='34.6' cy='20.4' r='2' className='fill-lime' />
        </svg>
    )
}
